<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->

      <page :url="url" :form="form" @select-data="handleSelectionChange">
        <template
          slot="tableSearch"
          v-if="$store.state.roleId == '1070960390067716097'"
        >
          <el-form-item label="代理商编号">
            <el-input
              v-model="form.agentId"
              placeholder="代理商编号"
            ></el-input>
          </el-form-item>

          <el-form-item label="结算状态">
            <el-select v-model="form.settlementStatus" style="width: 100px" placeholder="结算状态">
              <el-option label="全部" value=""></el-option>
              <el-option label="未结算" value="00"></el-option>
              <el-option label="已结算" value="01"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="日期">
            <el-date-picker
              v-model="timeDate"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyyMMdd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="timeChange"
            >
            </el-date-picker>
          </el-form-item>

        </template>

        <template
          slot="buttonArea"
          v-if="$store.state.roleId == '1070960390067716097'"
        >
          <el-button
            type="primary"
            @click="doAgentSettlement"
            size="small"
            :disabled="multipleSelection.length === 0"
            >批量结算</el-button
          >
        </template>

        <template slot="buttonArea">
          <el-button :loading="loading" type="primary" @click="exportDetail" size="small">
            导出报表</el-button>
        </template>

        <template slot="tableColumn">
          <el-table-column type="selection" width="50" align="center">
          </el-table-column>

          <el-table-column
            prop="settlementId"
            width="130px"
            label="结算编号"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="settlementPeriod"
            width="90px"
            label="订单日期"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="agentId"
            width="100px"
            label="代理Id"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="agentName"
            width="120px"
            label="代理名称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="appId"
            width="120px"
            label="商户id"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="appName"
            width="120px"
            label="商户名称"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="settlementStatus"
            :formatter="$formatter.formatSettlementStatus"
            width="120px"
            label="是否结算"
            align="center"
          >
          </el-table-column>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column
            prop="paymentAmount"
            width="80px"
            :formatter="$formatter.FenToYuan"
            label="代收金额"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="paymentMerRate"
            width="80px"
            label="商户费率"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="paymentAgentRate"
            width="80px"
            label="代理费率"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="paymentMerFee"
            width="90px"
            :formatter="$formatter.FenToYuan"
            label="商户手续费"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="paymentAgentFee"
            width="90px"
            :formatter="$formatter.FenToYuan"
            label="代理利润"
            align="center"
          >
          </el-table-column>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column
            prop="transferAmount"
            width="80px"
            :formatter="$formatter.FenToYuan"
            label="代付金额"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="transferMerRate"
            width="80px"
            label="商户费率"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="transferAgentRate"
            width="80px"
            label="代理费率"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="transferMerFee"
            width="90px"
            :formatter="$formatter.FenToYuan"
            label="商户手续费"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="transferAgentFee"
            width="90px"
            :formatter="$formatter.FenToYuan"
            label="代理利润"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="createTime"
            label="生成时间"
            width="160px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="updateTime"
            label="修改时间"
            width="100px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="updateRemark"
            label="修改备注"
            width="180px"
            align="center"
          >
          </el-table-column>

          <el-table-column
            fixed="right"
            label="操作"
            width="180"
            align="center"
            v-if="$store.state.roleId == '1070960390067716097'"
          >
            <template
              slot-scope="scope"
            >
              <el-button
                type="primary"
                plain
                size="mini"
                @click="edit(scope.row)"
                v-if="scope.row.settlementStatus != '01' && $store.state.roleId == '1070960390067716097'"
              >编辑</el-button>

              <el-button
                type="primary"
                plain
                size="mini"
                @click="doAgentSettlementBatch(scope.row, false)"
                v-if="scope.row.settlementStatus != '01' && $store.state.roleId == '1070960390067716097'"
              >结算</el-button>

            </template>
          </el-table-column>
        </template>
      </page>

      <AgentSettlementEdit
        :show.sync="isShowAgentSelDialog"
        :formData="formData"
        :action="action"
      ></AgentSettlementEdit>
    </div>
  </div>
</template>

<script>
import Page from '@/components/Page.vue'
import AgentSettlementEdit from './AgentSettlementEdit'
export default {
  name: 'Systems',
  components: {
    page: Page,
    AgentSettlementEdit: AgentSettlementEdit,
  },
  data() {
    return {
      isShowAgentSelDialog: false,
      formData: null,
      multipleSelection: [],
      strMultipleSelection: [],
      url: '/agentSettlement/selectAgentSettlementList',
      action: '',
      timeDate: [],
      form: {
        agentId: '',
        appId: '',
        startDate: '',
        endDate: '',
        settlementStatus: '',
      },
      fengexian:"||",
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
      this.strMultipleSelection = this.multipleSelection.map(
        ({ groupId }) => groupId
      )
    },

    timeChange(e) {
      if (e) {
        this.form.startDate = e[0]
        this.form.endDate = e[1]
      } else {
        this.form.startDate = ''
        this.form.endDate = ''
      }
    },
    reset() {
      this.timeDate = []
      this.form.startDate = ''
      this.form.endDate = ''
      this.form.agentId = ''
      this.form.appId = ''
      this.form.settlementStatus = ''
    },

    doAgentSettlement(row) {
      this.doAgentSettlementBatch(row, true)
    },

    reSettlement(row) {
      console.log(row)

      this.$confirm('确认要重算吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.axios
            .post('/agentSettlement/reSettlement', {
              settlementId: row.settlementId,
            })
            .then(res => {
              if (res.code === 200) {
                this.$notify({
                  title: '提示',
                  message: res.msg,
                  type: 'success',
                })
                // this.$bus.$emit('refresh') 
              } else {
                this.$notify.error({
                  title: '提示',
                  message: res.msg,
                })
              }
            })
        })
      .catch(() => {})
    },

    doAgentSettlementBatch(row, isBatch) {
      var ids = '';
      if (isBatch) {
        this.multipleSelection.forEach((v, i) => {
          if (v.settlementId) {
            ids = ids + v.settlementId + ",";
          }
        });
      } else {
        ids = row.settlementId
      }

      this.$confirm('确认要结算吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.axios
            .post('/agentSettlement/doAgentSettlement', {
              settlementIds: ids,
            })
            .then(res => {
              if (res.code === 200) {
                this.$notify({
                  title: '提示',
                  message: res.msg,
                  type: 'success',
                })
                this.$bus.$emit('refresh') //通知刷新
              } else {
                this.$notify.error({
                  title: '提示',
                  message: res.msg,
                })
              }
            })
        })
      .catch(() => {})
    },
    edit(row) {
      this.action = 'editAgent'
      this.formData = row

      this.isShowAgentSelDialog = true
    },

    exportDetail() {
      this.loading = true
      let params = {
        agentId: this.form.agentId,
        appId: this.form.appId,
        startDate: this.form.startDate,
        endDate: this.form.endDate,
        settlementStatus:this.form.settlementStatus,
      };
      this.axios
        .post("/agentSettlement/export", params)
        .then(res => {
          if (res.code != 200) {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'success',
            })
          }
        });
      this.loading = false
    },

  },
}
</script>

<style scoped>
</style>